<template>
  <div class="router-header flex flex-wrap items-center mb-6">
    <div
      class="pr-4 border-0 md:border-r border-t-0 border-b-0 border-l-0 border-solid border-grey-light">
      <h2 class="mb-1">{{ $t(pageTitle) }}</h2>
    </div>
    <Bread class="ml-4 md:block hidden" :breadcrumb="breadcrumb" />
    <!--<vs-dropdown class="ml-auto md:block hidden cursor-pointer" vs-trigger-click>-->
    <!--<vs-button radius icon="icon-settings" icon-pack="feather"></vs-button>-->

    <!--<vs-dropdown-menu class="w-32">-->
    <!--<vs-dropdown-item><router-link to="/pages/profile" class="flex items-center"><feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" /><span>Profile</span></router-link></vs-dropdown-item>-->
    <!--<vs-dropdown-item><router-link to="/apps/todo" class="flex items-center"><feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" /><span>Tasks</span></router-link></vs-dropdown-item>-->
    <!--<vs-dropdown-item><router-link to="/apps/email" class="flex items-center"><feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" /><span>Inbox</span></router-link></vs-dropdown-item>-->
    <!--</vs-dropdown-menu>-->
    <!--</vs-dropdown>-->
  </div>
</template>

<script>
import Bread from './Bread.vue'

export default {
  components: {
    Bread,
  },
  props: {
    pageTitle: String,
    breadcrumb: Array,
  },
  mounted() {},
}
</script>

<style lang="scss" scoped></style>
